import { ValidationResult } from '../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../../../utils/translator.helper';
import { ExchangeContentControlFilteringRuleFormValue } from '../../../../../../utils/uiSettings/exchange/exchange-protection.types';
import { ExchangeContentControlFilteringRule } from '@nirvana/shared/dtos/types/policies/common';

// validate duplicates
export function validateDuplicates(
  ruleItem: ExchangeContentControlFilteringRuleFormValue,
  rulesInGrid: ExchangeContentControlFilteringRule[]
): ValidationResult {
  const hasDuplicates = rulesInGrid.some(
    (ruleInGrid: ExchangeContentControlFilteringRule) => ruleInGrid.name === ruleItem.name
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
